import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AudioContext } from '../App';
// Correction de l'import : on utilise le nom exact exporté dans api.js
import { getCurrentFlash } from '../services/api'; 

const Header = () => {
  const { isPlaying, togglePlay, stopAudio } = useContext(AudioContext);
  const [flashMessage, setFlashMessage] = useState("Chargement des actualités...");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // État pour l'utilisateur synchronisé
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const isAuthorized = user && (user.role === 'Admin' || user.role === 'animateur');

  // Synchronisation lors du changement de page
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('user')));
  }, [location]);

  // Récupération du Flash Info via le service API
  useEffect(() => {
    const fetchFlash = async () => {
      try {
        // Utilisation du bon nom de fonction : getCurrentFlash
        const response = await getCurrentFlash();
        if (response.data && response.data.message) {
          setFlashMessage(response.data.message);
        }
      } catch (error) {
        setFlashMessage("Fréquence 974 : Restez branchés sur le meilleur son de l'île...");
        console.error("Erreur flash info:", error);
      }
    };

    fetchFlash();
    // Rafraîchissement toutes les 30 secondes
    const interval = setInterval(fetchFlash, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    setIsMenuOpen(false);
    window.location.href = '/'; 
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark shadow-sm sticky-top" style={{ background: 'linear-gradient(90deg, #002d5b 0%, #004a99 100%)', zIndex: 1050 }}>
        <div className="container">
          {/* LOGO */}
          <Link className="navbar-brand d-flex flex-column" to="/" onClick={() => setIsMenuOpen(false)}>
            <span className="fw-black italic tracking-tighter h3 mb-0 text-uppercase">
              FRÉQUENCE<span className="text-danger">974</span>
            </span>
            <small className="text-info text-uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '2px' }}>L'intensité de l'océan indien</small>
          </Link>
          
          <button 
            className="navbar-toggler border-0" 
            type="button" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse justify-content-center ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav gap-3 text-uppercase fw-bold py-3 py-lg-0" style={{ fontSize: '12px' }}>
              <li className="nav-item"><Link className="nav-link text-white" to="/" onClick={() => setIsMenuOpen(false)}>Accueil</Link></li>
              <li className="nav-item"><Link className="nav-link text-white" to="/direct" onClick={() => setIsMenuOpen(false)}>En Direct</Link></li>
              <li className="nav-item"><Link className="nav-link text-white" to="/pagevideo" onClick={() => setIsMenuOpen(false)}>Vidéos</Link></li>
              <li className="nav-item"><Link className="nav-link text-white" to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
              
              {isAuthorized && (
                <li className="nav-item">
                  <Link className="nav-link text-warning fw-black border border-warning rounded-pill px-3 d-inline-block" to="/dashboard" onClick={() => setIsMenuOpen(false)} style={{ fontSize: '11px' }}>
                    <i className="bi bi-person-badge-fill me-1"></i> Accès Studio
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* BLOC ACTIONS (AUDIO + AUTH) */}
          <div className="d-flex align-items-center gap-1 gap-md-3 mt-2 mt-lg-0">
            {/* LECTEUR */}
            <div className="d-flex align-items-center gap-1">
              <button 
                onClick={togglePlay} 
                className={`btn ${isPlaying ? 'btn-light text-primary' : 'btn-warning'} rounded-pill fw-black px-2 px-md-4 shadow-sm text-uppercase d-flex align-items-center`} 
                style={{ fontSize: '9px', minWidth: isPlaying ? '90px' : '115px' }}
              >
                {isPlaying ? (
                  <><i className="bi bi-pause-fill me-1 fs-6"></i>Pause</>
                ) : (
                  <><i className="bi bi-play-fill me-1 fs-6"></i> Direct</>
                )}
              </button>

              {isPlaying && (
                <button 
                  onClick={stopAudio}
                  className="btn btn-danger rounded-circle p-0 d-flex align-items-center justify-content-center shadow-sm"
                  style={{ width: '28px', height: '28px' }}
                >
                  <i className="bi bi-stop-fill fs-6"></i>
                </button>
              )}
            </div>

            {/* CONNEXION / DECONNEXION */}
            <div className="ms-1 border-start border-white border-opacity-25 ps-2">
                {user ? (
                  <button 
                    onClick={handleLogout}
                    className="btn btn-danger btn-sm rounded-pill px-2 px-md-3 fw-black text-uppercase d-flex align-items-center justify-content-center shadow-sm" 
                    style={{ fontSize: '9px', minHeight: '30px' }}
                  >
                    <i className="bi bi-power me-1"></i>
                    <span>Déconnexion</span>
                  </button>
                ) : (
                  <Link 
                    to="/login" 
                    onClick={() => setIsMenuOpen(false)}
                    className="btn btn-info btn-sm rounded-pill px-2 px-md-3 fw-black text-uppercase d-flex align-items-center justify-content-center shadow-sm text-white" 
                    style={{ fontSize: '9px', minHeight: '30px', backgroundColor: '#00bcd4', borderColor: '#00bcd4' }}
                  >
                    <i className="bi bi-lock-fill me-1"></i>
                    <span>Connexion</span>
                  </Link>
                )}
            </div>
          </div>
        </div>
      </nav>

      {/* --- FLASH INFO --- */}
      <div className="bg-black text-white py-2 border-bottom border-secondary border-opacity-25 shadow-sm overflow-hidden">
        <div className="container d-flex align-items-center">
          <div className="d-flex align-items-center" style={{ zIndex: 10, background: 'black', paddingRight: '15px' }}>
            <span className="badge bg-danger px-3 py-2 shadow-sm fw-black text-uppercase" 
                  style={{ animation: 'pulse-red 2s infinite', fontSize: '10px', letterSpacing: '1px' }}>
              <i className="bi bi-megaphone-fill me-2"></i>Flash Info
            </span>
          </div>
          
          <div className="marquee-container">
            <div className="marquee-text-content fw-bold text-white-50 italic">
              {flashMessage} &nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp; {flashMessage}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse-red {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7); }
          70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(220, 53, 69, 0); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
        }
        .marquee-container { flex: 1; overflow: hidden; display: flex; align-items: center; }
        .marquee-text-content { 
            display: inline-block; 
            white-space: nowrap; 
            padding-left: 100%; 
            animation: marquee-scroll 60s linear infinite; 
            font-size: 14px; 
        }
        @keyframes marquee-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-100%); } }
        .fw-black { font-weight: 900; }
        .italic { font-style: italic; }
      `}</style>
    </>
  );
};

export default Header;